import { useQuery } from "@tanstack/react-query";
import type { StrandAsset, StrandAssetScope } from "../../models/StrandAsset";
import { getStrandAssets } from "../../repositories/StrandLossesManagerRepository";

const STRANDS_ASSET_NAME = "STRANDS";

export const useStrandAssetsQuery = (
  onError?: (error: Error) => void,
  enabled = true,
) =>
  useQuery({
    queryKey: ["strand-assets"],
    queryFn: async ({ signal }): Promise<StrandAssetScope> => {
      const response = await getStrandAssets(signal);
      if (!response.ok) {
        throw new Error(response.message ?? "Failed to fetch Strand assets");
      }

      const assets = response.data as StrandAsset[];
      const parents = assets.filter(
        (asset) => asset.AssetName === STRANDS_ASSET_NAME,
      );
      if (parents.length !== 1) {
        throw new Error("Expected exactly one STRANDS parent asset");
      }

      const parentAssetId = parents[0].AssetId;
      const strands = assets
        .filter((asset) => asset.ParentAssetId === parentAssetId)
        .toSorted((left, right) =>
          left.AssetName.localeCompare(right.AssetName, undefined, {
            numeric: true,
          }),
        );
      if (strands.length === 0) {
        throw new Error("No Strand assets were found under STRANDS");
      }

      return { parentAssetId, strands };
    },
    onError,
    enabled,
  });
